import { render, staticRenderFns } from "./ServiceImagesSlider.vue?vue&type=template&id=1740cbb3"
import script from "./ServiceImagesSlider.vue?vue&type=script&lang=js"
export * from "./ServiceImagesSlider.vue?vue&type=script&lang=js"
import style0 from "./ServiceImagesSlider.vue?vue&type=style&index=0&id=1740cbb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports